export default {
  env: "live",
  test: {
    countyId: "151",
    serverURI: "http://188.166.0.245:8888",
    webSocketURI: "ws://188.166.0.245:8888/websocket"
  },
  live: {
    countyId: "151",
    serverURI: "https://api.zizi.co.ke",
    webSocketURI: "wss://api.zizi.co.ke/websocket"
  },
  appId: "webPortal",
  appVersion: "1.0.0",
  dateFormat: "DD/MM/YYYY HH:mm:ss",
  cardPaymentAvailable: false,
  maxMpesaTransaction: 70000,
  maxCardTransaction: 100000
};



// WEBPACK FOOTER //
// ./src/config/index.js